import type { DeviceType } from "@pandas/http-client";
import { StateCreator } from "zustand";
import { Storage } from "../index";

export type AssessmentResults = {
	[key: string]: {
		id: string;
		conditionId: string;
	};
};

export type SessionInfoSlice = {
	assessmentResults: AssessmentResults;
	sessionId: string | null;
	category: DeviceType;
	manualIdentification: boolean;
	clearSessionInfo: () => void;
	setSessionId: (_sessionId: string) => void;
	setAssessmentResults: (_name: string, _id: string, _condition: string) => void;
	setAttribute: <K extends keyof Pick<SessionInfoSlice, "category" | "manualIdentification">>(
		_attribute: K,
		_value: SessionInfoSlice[K],
	) => void;
};

const initialState: Pick<SessionInfoSlice, "assessmentResults" | "sessionId" | "category" | "manualIdentification"> = {
	assessmentResults: {},
	sessionId: null,
	category: "smartphone",
	manualIdentification: false,
};

export const createSessionSlice: StateCreator<Storage, [], [], SessionInfoSlice> = (set) => ({
	...initialState,
	setSessionId: (sessionId: string) =>
		set(() => ({
			sessionId: sessionId,
		})),
	setAssessmentResults: (name: string, id: string, condition: string) =>
		set((state) => {
			const updatedConditions = { ...state.assessmentResults };
			updatedConditions[name] = {
				id: id,
				conditionId: condition,
			};
			return {
				assessmentResults: updatedConditions,
			};
		}),
	clearSessionInfo: () => set(() => ({ ...initialState })),
	setAttribute: <K extends keyof Pick<SessionInfoSlice, "category" | "manualIdentification">>(
		attribute: K,
		value: SessionInfoSlice[K],
	) =>
		set(() => ({
			[attribute]: value,
		})),
});
